module.exports = require("./moment.js");


//////////////////
// WEBPACK FOOTER
// moment (bower component)
// module id = 126
// module chunks = 0